import { Button, Grid, Paper, Table, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import MigaPan from "../../../app/orussystem/component/MigaPan";
import { CreateNewResponse, EditResponse, ListResponsebyid } from "../../domain/EncuestasApi";
import { PollPanelStyle } from "../../infrastructure/PollPanelStyle";
import { useParams } from "react-router-dom";
import { Store } from "react-notifications-component";
import 'react-notifications-component/dist/theme.css'
import { panelUsersAuthStyle } from "../../../centraldevida/users_auth/panelUsersAuthStyle";
import ListResponse from "./listResponse";
import ModalResponse from "./modalFormResponse";
import theme from "../../../app/config/themaConfig";


export const PanelResponse = () => {
    const clases = panelUsersAuthStyle()

    const classes = PollPanelStyle();
    const [list, setList] = useState([])
    const [isLoanding, setIsLoanding] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [dataEdit, setdataEdit] = useState({})
    const [isReload, setIsReload] = useState(false)
    const [ID] = useState([])


    const [isEdit, setisEdit] = useState(false)
    let { id, idPoll } = useParams()
    let idQuestion = id === ":id" || id === "" ? 0 : id;
    let idEncuesta = idPoll === ":idPoll" || idPoll === "" ? 0 : idPoll;


    const setAsyncData = (data) => {
        return new Promise((resolve, reject) => {
            resolve(setdataEdit(data));
        })
    }

    const handledEditQuestion = async (data) => {
        setisEdit(true)
        setAsyncData(data).then((data) => setOpenModal(true))
    }

    const handledNewResponse = () => {
        setisEdit(false)
        setOpenModal(true)
    }

    const createResponse = (request) => {

        const data = {
            question: idQuestion,
            description: request.question,
            status: true
        }

        CreateNewResponse(data)
            .then((response) => {

                if (response.codigo === "0000") {

                    Store.addNotification({
                        title: "Creando Exitosamente!",
                        message: `la respuesta ${request.question} fue creada con exito!`,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    setIsReload(true)
                    setOpenModal(false)
                } else {
                    Store.addNotification({
                        title: "Algo salio mal",
                        message: response.mensaje,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    setIsReload(true)
                    setOpenModal(false);
                }

            }).catch((err) => {

            })

    }

    const editResponse = (request) => {

        EditResponse(request)
            .then((response) => {

                if (response.codigo === "0000") {

                    Store.addNotification({
                        title: "Editado Exitosamente!",
                        message: `la respuesta ${request.description} fue Editada con exito!`,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    setIsReload(!isReload)
                    setOpenModal(false);

                } else {
                    Store.addNotification({
                        title: "Algo salio mal",
                        message: response.mensaje,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    setIsReload(!isReload)
                    setOpenModal(false);

                }


            }).catch((err) => {

            })


    }

    useEffect(() => {
        const fetchData = async () => {
            // setIsLoanding(true)
            const listResponse = await ListResponsebyid(idQuestion);
            setList(listResponse.respuesta);
            setIsLoanding(false);
        }
        fetchData();
    }, [isReload, idQuestion]);
    const primaryColor = theme.palette.primary.main;


    return (
        <>
            {openModal && <ModalResponse
                setopenMondal={setOpenModal}
                isOpen={openModal}
                dataEdit={dataEdit}
                setdataEdit={setdataEdit}
                isEdit={isEdit}
                createResponse={createResponse}
                editResponse={editResponse}
                ID={ID}
                idQuestion={idQuestion}
            />}
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan namePage="Respuestas" to="/" namePage3="preguntas" to3={{
                    pathname: `/polls/preguntas/${idEncuesta}`

                }} namePage2="Encuestas" to2="/Pollpanel">
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} style={{ width: '100%' }} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.searchContainer} >
                            <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '1%', marginBottom: '2%', marginRight: '70%' }} color='primary'>Respuestas </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handledNewResponse}
                                style={{ borderRadius: '10px' }}
                            >
                                Nueva Respuesta
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '15%', color: primaryColor }}>Fecha creación</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '10%', width: '25%', color: primaryColor }}>Respuesta</TableCell>
                                        <TableCell className={clases.TableCell} style={{ width: '27.5%', paddingLeft: '15%', color: primaryColor }}>Estado </TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </Grid>
                        <Grid item xs={12}>
                            <ListResponse
                                rows={list}
                                isLoadUser={isLoanding}
                                handledEditQuestion={handledEditQuestion}
                                primaryColor={primaryColor}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        </>
    )
}